import React from 'react'
import Svg from '../../SvgComponent/Svg'
import { SvgProps } from '../../SvgComponent/types'

const Icon: React.FC<SvgProps> = (props) => {
  const { width, height } = props
  return (
    <Svg width={width || '24'} height={height || '24'} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="12" fill="#F0B90B" />
      <g clipPath="url(#clip0_6634_41255)">
        <path
          d="M12.0001 4.57227L7.96338 6.84727L9.44664 7.68298L12.0095 6.25298L14.5724 7.68298L16.0556 6.84727L12.0001 4.57227Z"
          fill="#101723"
        />
        <path
          d="M14.5631 8.88086L16.0463 9.71657V11.3973L13.4835 12.8273V15.6873L12.0002 16.523L10.517 15.6873V12.8273L7.9541 11.3973V9.71657L9.43737 8.88086L12.0002 10.3109L14.5631 8.88086Z"
          fill="#101723"
        />
        <path d="M16.037 12.5957V14.2764L14.5537 15.1121V13.4314L16.037 12.5957Z" fill="#101723" />
        <path
          d="M14.5347 16.2995L17.0975 14.8695V12.0095L18.5808 11.1738V15.7331L14.5441 18.0081V16.3088L14.5347 16.2995Z"
          fill="#101723"
        />
        <path
          d="M17.0882 9.13237L15.605 8.29665L17.0882 7.46094L18.5715 8.29665V9.97737L17.0882 10.8131V9.13237Z"
          fill="#101723"
        />
        <path
          d="M10.5171 18.5928V16.9121L12.0004 17.7478L13.4836 16.9121V18.5928L12.0004 19.4285L10.5171 18.5928Z"
          fill="#101723"
        />
        <path d="M9.44664 15.1199L7.96338 14.2842V12.6035L9.44664 13.4392V15.1199Z" fill="#101723" />
        <path d="M12.0004 9.13237L10.5171 8.29665L12.0004 7.46094L13.4836 8.29665L12.0004 9.13237Z" fill="#101723" />
        <path
          d="M8.39524 8.29665L6.91198 9.13237V10.8131L5.42871 9.97737V8.29665L6.91198 7.46094L8.39524 8.29665Z"
          fill="#101723"
        />
        <path
          d="M5.42871 11.1562L6.91198 11.992V14.852L9.47483 16.282V17.9627L5.42871 15.697V11.1562Z"
          fill="#101723"
        />
      </g>
      <defs>
        <clipPath id="clip0_6634_41255">
          <rect width="13.1429" height="14.8571" fill="white" transform="translate(5.42871 4.57227)" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Icon
